import BaseApiService from "./base-services/baseApi.service";

class FindTestApiService extends BaseApiService {
	constructor() {
		super();
	}

	getSpecializationList = async () => {
		const url = `/website/specialization/specialization-list`;
		const res = await this.axiosInstance.get(url);
		return await res.data;
	};
}
const findTestApiService = new FindTestApiService();
export { findTestApiService };
